export default ( props ) => {
  console.dir(props)
  return {
    'trial_users_id': {
      name: 'trial_users_id',
      nameKr: '아이디',
      elem: null,
      value: props.logInfo.userId
    },
    'trial_users_name': {
      name: 'trial_users_name',
      nameKr: '이름',
      elem: null,
      value: props.logInfo.userName
    },
    'trial_users_email': {
      name: 'trial_users_email',
      nameKr: '이메일',
      elem: null,
      value: props.logInfo.userEmail
    },
    'trial_biz_name': {
      name: 'trial_biz_name',
      nameKr: '회사명',
      elem: null,
      value: '',
      maxLen: 50,
      comment: '한글,영문, 숫자 50byte'
    },
    'trial_biz_phone': {
      name: 'trial_biz_phone',
      nameKr: '전화번호',
      elem: null,
      value: '',
      maxLen: 12,
      comment: '숫자만 입력'
    },
    'trial_ios': {
      name: 'trial_ios',
      nameKr: 'iOS',
      elem: null,
      value: '',
      maxLen: 50,
      comment: '한글,영문, 숫자 50byte',
      require: true,
      placeholder: 'iOS 번들아이디',
      validity: false
    },
    'trial_android': {
      name: 'trial_android',
      nameKr: 'Android',
      elem: null,
      value: '',
      maxLen: 50,
      comment: '한글,영문, 숫자 50byte',
      require: true,
      placeholder: '프로젝트명을 입력해주세요',
      validity: false
    }
  }
}